import React from 'react';
import AssetsContent from '../../component/assets/AssetsContent';

const AssetsContainer = () => {
  return <AssetsContent />;
};

export default AssetsContainer;
